import * as Yup from "yup";

export const Customevalidation = Yup.object().shape({
  FirstName: Yup.string().required("First Name is required"),
  LastName: Yup.string().required("Last Name is required"),
  CompanyName: Yup.string().required("Company Name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  phoneNumber: Yup.number().required("Phone number is required"),
  PaymentFrequency: Yup.string().required("Payment Frequency is required"),
  CustomerType: Yup.string().required("Customer Type is required"),
});
